import { render, staticRenderFns } from "./PageWithNavbar.vue?vue&type=template&id=f2623a10&scoped=true&"
import script from "./PageWithNavbar.vue?vue&type=script&lang=js&"
export * from "./PageWithNavbar.vue?vue&type=script&lang=js&"
import style0 from "./PageWithNavbar.vue?vue&type=style&index=0&id=f2623a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2623a10",
  null
  
)

export default component.exports